import { Outlet, useOutletContext } from 'react-router-dom'

import { Spinner } from '@factorialco/f0-react/dist/experimental'

import { useFeatures } from 'modules/core/hooks/useFeatures'
import { useMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { FormPreviewInline } from 'modules/forms'
import NewFormEditor from 'modules/forms/components/newFormEditor'
import { TrainingFormContextType } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/TrainingFormDetail/types'

const PublishedQuestions = () => {
  const context = useOutletContext<TrainingFormContextType>()

  const { trainingForm } = context
  const { navigation } = useNavigation()

  const { has_dev_forms_ai_cocreation: coCreationEnabled, loadingFeatures } = useFeatures([
    'dev_forms_ai_cocreation',
  ])
  const emptyNavigateAction = useMemo(() => {
    if (trainingForm.resourceId) {
      return navigation.trainings.list.details_revamp.trainingSurveyDetail.edit.fullPath({
        id: String(trainingForm.resourceId),
        formId: String(trainingForm.id),
      })
    } else {
      return navigation.trainings.list.surveyTemplates.templateDetails.edit.fullPath({
        templateId: String(trainingForm.id),
      })
    }
  }, [trainingForm.id])

  if (loadingFeatures) {
    return <Spinner />
  }

  if (coCreationEnabled) {
    return (
      <>
        <NewFormEditor
          id={trainingForm.id}
          resourceType={trainingForm.resourceType}
          formType="training-course-survey"
        />
        <Outlet context={context} />
      </>
    )
  }

  return (
    <>
      <FormPreviewInline
        formId={trainingForm.id}
        resourceId={trainingForm.resourceId ?? undefined}
        resourceType={trainingForm.resourceType}
        materializedForms={trainingForm.materializedForms}
        emptyNavigateAction={`${emptyNavigateAction}?create=true`}
      />
      <Outlet context={context} />
    </>
  )
}

export default PublishedQuestions
